import { render, staticRenderFns } from "./clueMoveApproveDetail.vue?vue&type=template&id=75203a2d&scoped=true&"
import script from "./clueMoveApproveDetail.vue?vue&type=script&lang=js&"
export * from "./clueMoveApproveDetail.vue?vue&type=script&lang=js&"
import style0 from "./clueMoveApproveDetail.vue?vue&type=style&index=0&id=75203a2d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75203a2d",
  null
  
)

export default component.exports